import api from 'Application/api/api';

const getAutomationFields = signal =>
	api.get('/step-templates/supported-automation-fields', {
		signal,
	});

export default getAutomationFields;
